

(function () {
  'use strict';

  function init(carouselEl) {
    if (carouselEl.__cerusLooxInit) return;
    carouselEl.__cerusLooxInit = true;

    var section = carouselEl.closest('section') || document;
    var sourceEl = section.querySelector('[data-cerus-loox-source]');
    var emptyEl = section.querySelector('[data-cerus-reviews-empty]');
    var listEl = carouselEl.querySelector('[data-cerus-reviews-list]');
    if (!sourceEl || !listEl) return;

    var source;
    if (sourceEl.tagName === 'TEMPLATE' && sourceEl.content) {
      source = sourceEl.content;
    } else {
      source = sourceEl;
    }

    var productTitle = carouselEl.dataset.productTitle || '';
    var productImage = carouselEl.dataset.productImage || '';
    var productUrl   = carouselEl.dataset.productUrl   || '';

    function tryRender() {
      var reviews = parseReviews(source);
      if (!reviews.length) return false;
      renderCards(listEl, reviews, { productTitle: productTitle, productImage: productImage, productUrl: productUrl });
      mountSplide(carouselEl);
      carouselEl.classList.add('is-ready');
      return true;
    }

    if (tryRender()) return;



    var tries = 0;
    var interval = setInterval(function () {
      tries++;
      if (tryRender() || tries > 6) {
        clearInterval(interval);
        if (tries > 6) {


          carouselEl.hidden = true;
          if (emptyEl) emptyEl.hidden = false;
        }
      }
    }, 200);
  }

  function parseReviews(source) {
    var out = [];

    source.querySelectorAll('.grid-item-wrap').forEach(function (item) {
      var grid = item.querySelector('.grid-item') || item;
      var titleEl = grid.querySelector('.title');
      var name = '';
      if (titleEl) {
        var clone = titleEl.cloneNode(true);
        var verifiedSpan = clone.querySelector('.verified-badge-and-text');
        if (verifiedSpan) verifiedSpan.remove();
        name = (clone.textContent || '').trim();
      }
      var verified = !!grid.querySelector('.verified-badge-and-text, .loox-verified-badge');

      var starsEl = grid.querySelector('.stars');
      var rating = 5;
      if (starsEl) {
        var labeled = starsEl.querySelector('[aria-label]');
        var label = labeled ? labeled.getAttribute('aria-label') || '' : '';
        var m = label.match(/(\d+(?:\.\d+)?)\s*\/\s*5/);
        if (m) rating = parseFloat(m[1]);
        else {
          var full = starsEl.querySelectorAll('svg[data-lx-fill="full"]').length;
          if (full > 0) rating = full;
        }
      }

      var textEl = grid.querySelector('.main-text, .review-text');
      var text = textEl ? (textEl.textContent || '').trim() : '';

      var titleHeading = '';
      var headingEl = grid.querySelector('.review-title, .main-title');
      if (headingEl) titleHeading = (headingEl.textContent || '').trim();

      var itemTypeEl = grid.querySelector('.item-type-value');
      var itemType = itemTypeEl ? (itemTypeEl.textContent || '').trim() : '';

      var imgEl = item.querySelector('img');
      var image = imgEl ? (imgEl.currentSrc || imgEl.src) : '';

      if (!name && !text) return;
      out.push({
        name: name, verified: verified, rating: rating,
        title: titleHeading, text: text, itemType: itemType, image: image
      });
    });

    if (out.length) return out;


    source.querySelectorAll('.review').forEach(function (item) {
      var nameEl = item.querySelector('.name');
      var textEl = item.querySelector('.review_text, .text, .review-text, .main-text');
      var name = nameEl ? (nameEl.textContent || '').trim() : '';
      var text = textEl ? (textEl.textContent || '').trim() : '';
      if (!name && !text) return;
      out.push({
        name: name,
        verified: true,
        rating: 5,
        title: '',
        text: text,
        itemType: '',
        image: ''
      });
    });

    return out;
  }

  function starsHtml(rating) {
    var full = Math.floor(rating);
    var hasHalf = (rating - full) >= 0.5;
    var html = '';
    for (var i = 1; i <= 5; i++) {
      if (i <= full) html += '<i class="fa-sharp fa-solid fa-star"></i>';
      else if (i === full + 1 && hasHalf) html += '<i class="fa-sharp fa-solid fa-star-half-stroke"></i>';
      else html += '<i class="fa-sharp fa-regular fa-star"></i>';
    }
    return html;
  }

  function renderCards(listEl, reviews, ctx) {
    listEl.innerHTML = reviews.map(function (r) {
      var thumb = ctx.productImage;
      var productLabel = r.itemType || ctx.productTitle;
      var title = r.title;
      if (!title && r.text) {
        var words = r.text.split(/\s+/).slice(0, 6).join(' ').replace(/[.,!?]$/, '');
        title = words + (r.text.split(/\s+/).length > 6 ? '…' : '');
      }

      return [
        '<li class="splide__slide cerus-review-card">',
          '<div class="cerus-review-card__stars" aria-label="' + r.rating + ' out of 5 stars">' + starsHtml(r.rating) + '</div>',
          title ? '<h3 class="cerus-review-card__title">' + escape(title) + '</h3>' : '',
          '<p class="cerus-review-card__text">' + escape(r.text) + '</p>',
          '<div class="cerus-review-card__divider"></div>',
          '<div class="cerus-review-card__footer">',
            '<div class="cerus-review-card__reviewer">',
              '<span class="cerus-review-card__name">' + escape(r.name || 'Verified athlete') + '</span>',
              r.verified ? '<span class="cerus-review-card__verified"><i class="fa-solid fa-circle-check"></i> Verified Buyer</span>' : '',
            '</div>',
            (productLabel || thumb) ? [
              '<a class="cerus-review-card__product" href="' + escape(ctx.productUrl || '#') + '">',
                '<span class="cerus-review-card__product-info">',
                  '<span class="cerus-review-card__product-label">Reviewing</span>',
                  '<span class="cerus-review-card__product-name">' + escape(productLabel) + '</span>',
                '</span>',
                thumb ? '<span class="cerus-review-card__product-thumb"><img src="' + escape(thumb) + '" alt="" loading="lazy"></span>' : '',
              '</a>'
            ].join('') : '',
          '</div>',
        '</li>'
      ].join('');
    }).join('');
  }

  function escape(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function mountSplide(el) {
    if (!window.Splide) return;
    if (el.__cerusSplide) return;
    var slides = el.querySelectorAll('.splide__slide').length;
    var perPage = Math.min(3, Math.max(1, slides));
    var splide = new window.Splide(el, {
      type: slides > perPage ? 'loop' : 'slide',
      perPage: perPage,
      perMove: 1,
      gap: '20px',
      arrows: false,
      pagination: false,
      drag: true,
      flickPower: 360,
      padding: { left: 2, right: 2 },
      breakpoints: {
        1100: { perPage: Math.min(2, slides), gap: '16px' },
        749:  { perPage: 1.1, gap: '14px' }
      }
    });
    splide.mount();
    el.__cerusSplide = splide;

    var prevBtn = el.querySelector('[data-cerus-reviews-prev]');
    var nextBtn = el.querySelector('[data-cerus-reviews-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { splide.go('<'); });
    if (nextBtn) nextBtn.addEventListener('click', function () { splide.go('>'); });
  }

  function initAll(root) {
    var scope = (root && root.querySelectorAll) ? root : document;
    scope.querySelectorAll('[data-cerus-reviews-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
